<span class="mat-body-1">Please login by clicking: </span>
<button mat-raised-button (click)="login()">here</button>

<ng-container *ngIf="authFacade.error$ | async">
	ERROR: {{ authFacade.error$ | async }}
</ng-container>
